import Vue from "vue";

import Router from "vue-router";
import index from './views/index.vue'

Vue.use(Router);
export default new Router({
    mode: 'history', //上线


    base: 'testsmarcode',//博世亚太测试
    routes: [
        {
            path: '/',
            name: 'index',
            component: index,
            meta: {
                keepAlive: false // 首页
            }
        },
        {
            path: '/result_smart',
            name: 'result_smart',
            component: resolve => require(['@/views/detail/result-smart.vue'], resolve),
            meta: {
                keepAlive: false //
            }
        },
        {
            path: '/feedback',
            name: 'feedback',
            component: resolve => require(['@/views/detail/feedback.vue'], resolve),
            meta: {
                keepAlive: false //
            }
        },
        {
            path: '/product_detail',
            name: 'product_detail',
            component: resolve => require(['@/views/detail/product-detail.vue'], resolve),
            meta: {
                keepAlive: false //
            }
        },
        
       
    ],


});
